export const isSearchPopulated = (search: App.ProductSearch.Search = {}): boolean => Object
    .values(search)
    .reduce((accum: boolean, value) => (accum || !!(Array.isArray(value) ? value.length : value)), false);
